import { drizzle } from 'drizzle-orm/d1'
import * as schema from './schema/index.js'
import bcrypt from 'bcryptjs'

export async function seedDatabase(d1: D1Database) {
  const db = drizzle(d1, { schema })
  
  console.log('🌱 Seeding database...')

  try {
    // Create admin user if it doesn't exist
    const existingAdmin = await db.select().from(schema.adminUsers).where(schema.eq(schema.adminUsers.username, 'admin')).limit(1)
    
    if (!existingAdmin[0]) {
      const hashedPassword = await bcrypt.hash('admin123', 10)
      
      await db.insert(schema.adminUsers).values({
        username: 'admin',
        password_hash: hashedPassword,
        created_at: new Date().toISOString(),
      })
      
      console.log('✅ Admin user created (username: admin, password: admin123)')
    } else {
      console.log('ℹ️ Admin user already exists')
    }

    // Create sample users if none exist
    const existingUsers = await db.select().from(schema.users).limit(1)
    
    if (!existingUsers[0]) {
      const sampleUsers = [
        {
          namn: 'John Doe',
          epost: 'john@example.com',
          telefon: '+46701234567',
          vouchers: 5,
          completed_trainings: 2,
          created_at: new Date().toISOString(),
        },
        {
          namn: 'Jane Smith',
          epost: 'jane@example.com',
          telefon: '+46701234568',
          vouchers: 3,
          completed_trainings: 1,
          created_at: new Date().toISOString(),
        },
      ]

      await db.insert(schema.users).values(sampleUsers)
      console.log('✅ Sample users created')
    } else {
      console.log('ℹ️ Users already exist')
    }

    // Create sample trainings if none exist
    const existingTrainings = await db.select().from(schema.trainings).limit(1)
    
    if (!existingTrainings[0]) {
      const sampleTrainings = [
        {
          titel: 'Introduction to React',
          beskrivning: 'Learn the basics of React development',
          datum: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(), // Next week
          location: 'Stockholm',
          max_platser: 20,
          bootcamp: 0,
          free_training: 0,
          allow_non_bootcamp_join: 1,
          created_at: new Date().toISOString(),
          anmalda: 0,
        },
        {
          titel: 'Advanced TypeScript',
          beskrivning: 'Deep dive into TypeScript features',
          datum: new Date(Date.now() + 14 * 24 * 60 * 60 * 1000).toISOString(), // Two weeks from now
          location: 'Gothenburg',
          max_platser: 15,
          bootcamp: 1,
          bootcamp_name: 'Full Stack Bootcamp',
          free_training: 0,
          allow_non_bootcamp_join: 0,
          created_at: new Date().toISOString(),
          anmalda: 0,
        },
      ]

      await db.insert(schema.trainings).values(sampleTrainings)
      console.log('✅ Sample trainings created')
    } else {
      console.log('ℹ️ Trainings already exist')
    }

    console.log('🎉 Database seeding completed!')
  } catch (error) {
    console.error('❌ Error seeding database:', error)
    throw error
  }
}
